import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { DotsLoader, Text, ThemeContext } from '..';

export const LoadingPage = ({ text }: LoadingPageProps): React.JSX.Element=> {
  const theme = useContext(ThemeContext);
  const styles = getStyles(theme);

  return (
    <View style={styles.container}>
      {!!text && <Text style={styles.text}>{text}</Text>}
      <DotsLoader />
    </View>
  );
};

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      alignItems: 'center',
      backgroundColor: theme.colors.secondary.normal,
      flex: 1,
      justifyContent: 'center',
    },
    text: {
      color: theme.colors.primary.normal,
      marginBottom: 32,
    },
  });

interface LoadingPageProps {
  text?: string;
}
